<div class="vipinfo-wrapper">
  <div class="selector-div-wrapper">
    <p><small>Mostrar</small></p>
    <div class="form-check form-switch">
      <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="vipinfo-switch"
        [(ngModel)]="tool.enabled" />
    </div>
  </div>
  <div *ngIf="tool.enabled">
    <div class="tabs">
      <div class="tab">
        <button (click)="tabs.active = 'contents'" [ngClass]="{ active: tabs.active === 'contents' }">Contents</button>
      </div>
      <div class="tab">
        <button (click)="tabs.active = 'colors'" [ngClass]="{ active: tabs.active === 'colors' }">Colors</button>
      </div>
    </div>
    <div class="tabs-content">
      <app-vipinfo-contents (createNewButton)="onCreateButton($event)" [hidden]="tabs.active !== 'contents'"
        (editButton)="onEdit($event)" [vipButtons]="vipButtons"></app-vipinfo-contents>
      <app-vipinfo-colors [hidden]="tabs.active !== 'colors'" [defaultButton]="defaultButton" [linkButton]="linkButton"
        [vipButtons]="vipButtons" (colorChange)="onColorChange($event)"
        [vipInfoEditColorsDisplay]="vipInfoEditColorsDisplay"></app-vipinfo-colors>
    </div>
  </div>
</div>
<div class="tabs-bottom">
  <button class="btn-secondary-action" (click)="apply()">Aplicar cambios</button>
</div>

<div class="modal-wrapper slideup" *ngIf="isEditing">
  <div class="w-100 p-2">
    <app-vipinfo-modal [vipInfoButton]="editingButton" (cancel)="onCancel()" (save)="onSave($event)"
      (delete)="onDelete($event)"></app-vipinfo-modal>
  </div>
</div>